/** Get user initials from first and last name */
export function getInitials(firstName?: string, lastName?: string): string {
  const first = firstName?.[0] || '';
  const last = lastName?.[0] || '';
  return (first + last).toUpperCase() || 'U';
}

/** Get full name from first and last name */
export function getFullName(firstName?: string, lastName?: string): string {
  return [firstName, lastName].filter(Boolean).join(' ') || 'User';
}
